<ng-container *ngIf="filteredQuestions.length > 0; else noQuestionFound">
  <ng-container *ngFor="let question of filteredQuestions; let i = index">
    <div class="topic-question">
      <div
        class="topic-question__title"
        [ngClass]="
          selectedQuestionIndex === i
            ? 'topic-question__title active'
            : 'topic-question__title'
        "
        (click)="toggleAccordian(i); $event.stopPropagation()"
      >
        {{ question.question }}
        <app-action-menu
          topPosition="19px"
          rightPosition="20px"
          [isOpen]="menuOpenIndex === i"
          (delete)="handleDelete(i)"
          (edit)="handleEdit(i)"
          (outsideClick)="closeAllMenu(i)"
          (open)="openMenu(i)"
        ></app-action-menu>
      </div>
      <div
        [ngClass]="
          selectedQuestionIndex === i
            ? 'topic-question__content active'
            : 'topic-question__content'
        "
        [innerHTML]="question.answer"
      ></div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="deleteQuestionIndex > -1">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you want to delete this Question?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="closeDeleteModal()"
    (onSecondaryButtonClick)="deleteQuestion()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>

<ng-template #noQuestionFound>
  <div class="topic-question__nodata">No Data Found</div>
</ng-template>
